<template>
  <div class="home">
    <small-chart ref="smallChart" api="/js-order/last-month"></small-chart>
    <!--发布新需求-->
    <div class="content">
      <div class="sx main-btn" style="flex-direction:column;align-items:flex-start;gap:8px;">
        <button class="btn new-t-btn c" @click.stop="taskOpen">
          <img src="../assets/imgs/push1.svg" width="16" height="16">
          <p>新的订单</p>
        </button>
        <div style="display:flex;align-items:center;gap:6px;">
          <button class="btn c" @click="exportShow = !exportShow" style="padding:5px 10px;background:#f4f5f7;border:1px solid #dfe1e6;border-radius:3px;cursor:pointer;font-size:16px;line-height:1;" title="导出订单">
            📥
          </button>
          <template v-if="exportShow">
            <form autocomplete="off" style="display:inline-flex;align-items:center;gap:6px;">
              <el-date-picker
                v-model="exportMonth"
                type="month"
                placeholder="选择月份"
                value-format="yyyy-MM"
                style="width:140px;">
              </el-date-picker>
              <button class="btn c" :class="{'loading': exporting}" @click.prevent="exportOrders" :disabled="!exportMonth || exporting" style="padding:7px 12px;background:#409eff;color:#fff;border:1px solid #409eff;border-radius:3px;cursor:pointer;">
                <span v-if="exporting">导出中...</span>
                <span v-else>确认导出</span>
              </button>
            </form>
          </template>
        </div>
      </div>
    </div>
    <!--筛选-->
    <div class="content">
      <div class="sx">
        <!--菜单-->
        <div :class="$isPhone() ? 'navs-m' : 'navs'">
          <!-- 「下单人」筛选：可点击触发的下拉（可输入搜索）+ 头像。
               ⚠️ 浏览器自动填充（Chrome 存过登录账号）会猜填进这里的输入框，
               故 el-select 设 autocomplete="off"，并在前面再放一个隐藏假密码框把自动填充引开。
               1329 个客户若常驻 DOM、且每项都带头像，会瞬间发起上千个图片请求拖垮筛选栏，
               故用 remote + 本地缓存，每次只渲染前 orderUserMax 条（见 searchOrderUser / onOrderUserVisible）。 -->
          <input class="autofill-decoy" type="password" name="__no_autofill_orderuser__" autocomplete="new-password" tabindex="-1" aria-hidden="true">
          <div class="order-user-wrap" :class="{'has-picked': !!selectedOrderUser}">
            <!-- 已选下单人头像：有头像走 img，没有则退化成「姓名首字圆点」（与 User.vue 同配色）。
                 必须同时判 profile —— handleUrl 空值安全（null ⇒ 空串，不抛错），
                 但只判对象非空会渲染出 src="" 的破图。 -->
            <img v-if="selectedOrderUser && selectedOrderUser.profile" class="order-user-picked" :src="selectedOrderUser.profile | handleUrl" alt="">
            <span v-else-if="selectedOrderUser" class="order-user-picked order-user-picked-initial" :style="{ background: avatarColor(selectedOrderUser.name) }">{{ avatarInitial(selectedOrderUser.name) }}</span>
            <el-select
                v-model="apiFilter.customerUserId"
                class="order-user-select"
                size="small"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="下单人"
                autocomplete="off"
                :remote-method="searchOrderUser"
                @change="loadData()"
                @visible-change="onOrderUserVisible">
              <el-option v-for="u in list.orderUser" :key="u.id" :label="u.name" :value="u.id">
                <span class="order-user-opt">
                  <!-- 有头像走 img；没有（profile 为 null/空）退化成姓名首字圆点，否则会渲染出 src="" 的破图 -->
                  <img v-if="u.profile" class="order-user-opt-avatar" :src="u.profile | handleUrl" alt="">
                  <span v-else class="order-user-opt-avatar order-user-opt-initial" :style="{ background: avatarColor(u.name) }">{{ avatarInitial(u.name) }}</span>
                  <span class="order-user-opt-name">{{ u.name }}</span>
                </span>
              </el-option>
            </el-select>
          </div>
          <!-- 「下单日期」只保留日期控件，去掉文字标签占位；含义改为鼠标悬停提示（title）
               ⚠️ 浏览器自动填充（Chrome 保存过登录账号）会把账号名之类猜填进日期框、甚至顶开日历面板。
               故设 :editable="false"（两个区间输入框变 readonly，浏览器不再自动填充），
               并在前面放一个隐藏的假密码框把自动填充引开（见 .autofill-decoy）。
               仅禁「自动填充/手输」，点输入框照样打开日历面板。 -->
          <div class="fenpei zd nav-p" :class="{'active a' : apiFilter.dateRange && apiFilter.dateRange.length}" title="下单日期">
            <input class="autofill-decoy" type="password" name="__no_autofill__" autocomplete="new-password" tabindex="-1" aria-hidden="true">
            <el-date-picker
                v-model="apiFilter.dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="~"
                start-placeholder="开始"
                end-placeholder="结束"
                size="small"
                :editable="false"
                style="width:230px;">
            </el-date-picker>
          </div>
          <p :class="{'active a' : eq('noDeliver')}" @click="type = 'noDeliver'">未发 ({{ listInfo.countNoDeliver }})</p>
          <p :class="{'active a' : eq('isDeliverNoPay')}" @click="type = 'isDeliverNoPay'">已发未付 ({{ listInfo.countIsDeliverNoPay }})</p>
          <p :class="{'active a' : eq('history')}" @click="type = 'history'">全部 ({{ listInfo.countHistory }})</p>
          <!-- 「外发」「外发未做」入口已关闭（功能逐步弃用）：仅隐藏 UI，后端逻辑与字段保留，便于日后回收 -->
        </div>
      </div>
      <div class="search">
        <form autocomplete="off">
          <el-input
              class="search-input"
              @input="loadData()"
              placeholder="搜索：内容／金额／下单人"
              v-model="searchKey"
              autocomplete="off"
              clearable>
          </el-input>
        </form>
      </div>
      <div class="laser-mode-box">
        <div class="img-btn c" :class="{a: isCalendarMode}" @click="isCalendarMode = !isCalendarMode">
          <img src="@/assets/imgs/calendar.svg" v-if="!isCalendarMode">
          <img src="@/assets/imgs/calendar-a.svg" v-if="isCalendarMode">
          <div class="mode-card">卡片模式</div>
        </div>
        <div class="img-btn c" :class="{a: !isCalendarMode}" @click="isCalendarMode = !isCalendarMode">
          <img src="@/assets/imgs/order.svg" v-if="isCalendarMode">
          <img src="@/assets/imgs/order-a.svg" v-if="!isCalendarMode">
          <div class="mode-list">列表模式</div>
        </div>
      </div>
    </div>
    <!--任务列表-卡片模式-->
    <div v-loading="loading.order" class="c" v-if="isCalendarMode">
      <div class="content v-c-t card">
        <div v-for="(item, index) in realList" :key="index" class="card-item cp" :class="{a: show.cardItem[index]}">
          <router-link :to="{path:`/js-order/${item.id}`}">
            <!-- 缩略图必须走 orderPics() 归一化：后端 pics 可能是 NULL / '' / JSON 字符串 / 挂在 order.pics 上。
                 直连 item.pics[0] 时：NULL ⇒ 渲染期 TypeError（整块卡片列表不落地）、'' ⇒ 破图、
                 JSON 字符串 ⇒ 取到首字符 '[' 当 src。列表模式一直用的是 orderPics()，这里对齐。 -->
            <img v-if="orderPics(item).length" :src="orderPics(item)[0]" class="card-img" @click.stop.prevent="setShowOrderItemImg(index)">
            <p class="card-title">{{ item.title }}</p>
            <div class="card-user user">
              <User :user="item.customerUser" style="justify-content: flex-start"></User>
            </div>
            <div class="card-mark">
              <span class="mark" :class="[item.isPay ? 'ok' : 'mark-err']">{{ item.isPay ? '已付' : '未付' }}</span>
              <span class="mark" :class="[item.isDeliver ? 'ok' : 'mark-err']">{{ item.isDeliver ? '已发' : '未发' }}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!--任务列表-列表模式-->
    <div v-loading="loading.order" class="content v-c-t" v-if="!isCalendarMode">
      <table class="i-tab" cellspacing="0">
        <tr class="t tb-head">
          <th></th>
          <th class="tl">接单</th>
          <th class="tl" width="300">标题</th>
          <th class="tl">下单时间</th>
          <th class="tl">发付</th>
          <th class="tl">金额</th>
          <th class="tl">客户</th>
          <th class="tl" v-if="type === 'isOutbound' || type === 'isOutboundNoDeliver'">外发</th>
          <th class="tl pic-head">图片</th>
        </tr>
        <tr class="t"
            v-for="(item, index) in realList"
            @click.stop="taskOpen(item, index)"
            :class="{ 'bg-active': rowBgActive[index] }"
            :key="index">
          <td>{{ index + 1 }}</td>
          <td class="tl create-user">
            <User :user="item.createUser" style="justify-content: flex-start"></User>
          </td>
          <td class="title tl"><p>{{ item.title }}</p></td>
          <td class="tl">{{ formatMD(item.createTime) }}
          </td>
          <td class="tl">
            <span class="mark" :class="[item.isPay ? 'ok' : 'mark-err']">{{ item.isPay ? '已付' : '未付' }}</span>
            <span class="mark" :class="[item.isDeliver ? 'ok' : 'mark-err']">{{ item.isDeliver ? '已发' : '未发' }}</span>
          </td>
          <td class="tl">
            {{ item.money | toFixed2 }}
          </td>
          <td class="tl customer-user">
            <User :user="item.customerUser" style="justify-content: flex-start"></User>
          </td>
          <td class="tl" v-if="type === 'isOutbound' || type === 'isOutboundNoDeliver'">
            <User v-if="item.outboundUser" :user="item.outboundUser" style="justify-content: flex-start"></User>
          </td>
          <!--订单图片速览板：表格里直接看图纸缩略图（点图看大图、点整行开订单）-->
          <td class="tl pic-cell">
            <div v-if="orderPics(item).length" class="pic-strip">
              <img v-for="(pic, pi) in orderPics(item).slice(0, picPreviewMax)"
                   :key="pi"
                   :src="pic"
                   class="pic-thumb"
                   loading="lazy"
                   @click.stop.prevent="previewPics(item, pi)">
              <span v-if="orderPics(item).length > picPreviewMax"
                    class="pic-more"
                    @click.stop.prevent="previewPics(item, picPreviewMax)">+{{ orderPics(item).length - picPreviewMax }}</span>
            </div>
            <span v-else class="pic-none">—</span>
          </td>
        </tr>
      </table>
    </div>
    <!--任务列表手机版-->
    <div class="task">
      <div class="task-content">
        <div id="wancheng-1" class="list-group v-un-drag">
          <div class="t" v-for="(item, index) in realList" @click.stop="taskOpen(item)" :key="index">
            <div class="item-title">
              <img v-if="item.status === '已完成'" src="../assets/imgs/done.svg" width="19" height="19">
              <p>{{ item.title }}</p>
            </div>
            <div class="v-u">
              <div class="u y">
                <div class="sp" v-show="item.wanchengDate">
                  <p>预计：{{ formatYMD(item.wanchengDate) }}</p>
                </div>
                <div class="sp" v-show="item.wanchengXiaoshi">
                  耗时：{{ item.wanchengXiaoshi }}H
                </div>
              </div>
              <div class="u">
                <p>发起：</p>
                <img v-if="item.fabu && item.fabu.img" class="avatar-inline" :src="`${baseURL + item.fabu.img}`">
                <span v-else-if="item.fabu" class="avatar-inline avatar-inline-initial" :style="{ background: avatarColor(item.fabu.name) }">{{ avatarInitial(item.fabu.name) }}</span>
                <p v-if="item.chuli">处理：</p>
                <img v-if="item.chuli && item.chuli.img" class="avatar-inline" :src="`${baseURL + item.chuli.img}`">
                <span v-else-if="item.chuli" class="avatar-inline avatar-inline-initial" :style="{ background: avatarColor(item.chuli.name) }">{{ avatarInitial(item.chuli.name) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="realList.length > 0" class="content v-c-t gonghaoshi cp" @click="nextPage" v-show="listInfo.pageInfo.pageNum < listInfo.pageInfo.lastPage">
      <div>点击加载更多订单</div>
    </div>
    <router-view/>
    <ImgViewer ref="imgViewer"></ImgViewer>
  </div>
</template>

<script>
import util from "../util";
import dateUtil from "../date-util"
import User from "@/components/User";
import ImgViewer from "@/components/ImgViewer";
import mySocket from "@/components/mySocket";
import SmallChart from "@/components/Charts/SmallChart";
import { avatarColor, avatarInitial } from '@/utils/avatar'

export default {
  name: 'Xuqiu',
  components: {User, ImgViewer, SmallChart},
  data () {
    return {
      list: {
        history: [],
        noDeliver: [],
        isOutbound: [],
        isOutboundNoDeliver: [],
        isDeliverNoPay: [],

        // 下单人下拉「当前渲染项」：仅在下拉展开时填充、收起即清空，
        // 避免 1329 个 <el-option> 常驻 DOM
        orderUser: []
      },
      // 下单人全量缓存：首次展开下拉时从 /user/list-order-customer 拉取一次
      orderUserCache: [],
      // 下拉每次最多渲染多少条：1329 条全渲染、且每项带头像，会瞬间发起上千个图片请求
      orderUserMax: 50,
      listInfo: {},
      type: 'noDeliver',
      // 图片速览板每行最多显示几张缩略图（超出显示 +N，点击进大图；改这一个数即可）
      picPreviewMax: 2,
      apiFilter: {
        // 保留字段以兼容后端 customerUserId 参数；UI 已不再直接指定（下单人改为在搜索框输入）
        customerUserId: null,
        // 下单日期区间 [startDate, endDate]（yyyy-MM-dd）；null / 空数组 = 不筛选
        dateRange: null
      },
      show: {
        cardItem: {}
      },
      loading: {
        nextPage: false,
        order: false
      },
      isOnlyMe: false,
      isZdUserLoading: false,
      zdUsers: [],
      curEditTask: null,
      countNeedGrade: 0,
      countTaskTimeout: 0,
      calendarOption: {},
      specialDays: null,

      isCalendarMode: false,
      searchKey: '',
      exportMonth: '',
      exportShow: false,
      exporting: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
    // 已选中的下单人（用于在输入框左侧叠一个头像）；从全量缓存里找，缓存没加载就没有头像
    selectedOrderUser () {
      if (!this.apiFilter.customerUserId) return null
      return (this.orderUserCache || []).find(u => u.id === this.apiFilter.customerUserId) || null
    },
    realList () {
      return this.listInfo && this.listInfo.pageInfo && this.listInfo.pageInfo.list || []
    },
    // 按 chuliId 连续分组：组内同色，跨组交替底色（替代原 classBg 渲染期副作用写法）
    rowBgActive () {
      const list = this.realList
      const map = {}
      let lastChildId = null
      let lastCss = null
      list.forEach((item, index) => {
        if (index === 0) {
          lastChildId = item.chuliId
          lastCss = null
          map[index] = false
          return
        }
        if (item.chuliId === lastChildId) {
          map[index] = !!lastCss
        } else {
          lastChildId = item.chuliId
          lastCss = lastCss ? null : { 'bg-active': true }
          map[index] = !!lastCss
        }
      })
      return map
    }
  },
  watch: {
    user () {
      this.loadData()
    },
    type () {
      // 与下方 apiFilter 同款守卫：首次响应回来之前 listInfo 仍是 data 初值 {}（loadData 只在 $get 回调里赋值），
      // pageInfo 为 undefined ⇒ 这段时间点 tab 会 TypeError；且异常会让下一行 setTimeout 不执行
      // ⇒ 表现为"切了 tab 但列表不刷新、只在控制台报错"。
      if (this.listInfo.pageInfo)
        this.listInfo.pageInfo.list.splice(0, this.listInfo.pageInfo.list.length)
      setTimeout(this.loadData, 20)
    },
    apiFilter: {
      handler () {
        if (this.listInfo.pageInfo)
          this.listInfo.pageInfo.list.splice(0, this.listInfo.pageInfo.list.length)
        setTimeout(this.loadData, 20)
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    handleScroll () {
      // console.log('s', e)
      // const {scrollTop, clientHeight, scrollHeight} = e.target.document
      const {scrollTop, clientHeight, scrollHeight} = document.documentElement
      // const _t = this.$(e.target)
      // let scrollTop = _t.scrollTop()
      // let clientHeight = _t.clientHeight()
      // let scrollHeight = _t.scrollHeight()
      // console.log(`${scrollTop} + ${clientHeight} + 100 >= ${scrollHeight}`, scrollTop, clientHeight, scrollHeight)
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        this.nextPage()
      }
    },
    closeAll () {
    },
    eq (type) {
      return type === this.type
    },
    formatMD (date) {
      if (!date) return '';
      let f = this.toDate(date);
      let now = new Date();
      if (f.getFullYear() !== now.getFullYear())
        return f.Format('yyyy年MM月dd日');
      return f.Format('M月d');
    },
    formatYMD (date) {
      return util.friendlyDate1(new Date(date))
    },
    toDate (date) {
      if (typeof date == 'number')
        return new Date(date);
      else
        return new Date(date.replace(/-/g, '/').replace('T', ' '));
    },
    tipDate (date) {
      if (!date) return '';
      const now = new Date(new Date().Format('yyyy/MM/dd'));
      const f = this.toDate(date);
      if (now.getTime() > f.getTime()) return '过期';
      if (f.getTime() === now.getTime()) return '今天';
      if (f.getTime() - now.getTime() === 24 * 60 * 60 * 1000) return '明天';
      if (f.getTime() - now.getTime() === 2 * 24 * 60 * 60 * 1000) return '后天';
      return (f.getTime() - now.getTime()) / 24 / 60 / 60 / 1000 + '天'
    },
    tipDateClass (date) {
      if (!date) return '';
      var now = new Date(new Date().Format('yyyy/MM/dd'));
      var f = this.toDate(date);
      if (now.getTime() > f.getTime()) return 'guoqi';
      if (f.getTime() === now.getTime()) return 'today';
      return 'mdd'
    },
    // 下单人下拉：展开时才把候选铺进 DOM（首次展开拉一次全量），收起立即清空。
    // 1329 个客户如果常驻 DOM（且每项都带头像），会拖慢整个筛选栏、并瞬间发起上千个图片请求。
    // 「收起清空」不会让已选项退化：element-ui 2.15.14 在选中时已把选项对象缓存进
    // this.selected（selectedLabel 取自 selected.currentLabel），
    // 实测把选项数组清空后显示文案仍是客户名（见 _probe/select-options-clear.js）。
    onOrderUserVisible (visible) {
      if (!visible) {
        this.list.orderUser = []
        return
      }
      if (this.orderUserCache.length) {
        this.searchOrderUser('')
        return
      }
      this.$get('/user/list-order-customer', {}, res => {
        this.orderUserCache = res || []
        this.searchOrderUser('')
      })
    },
    // 下拉内输入搜索（el-select 的 remote-method）：在本地缓存里过滤，只渲染前 orderUserMax 条
    searchOrderUser (query) {
      const kw = String(query == null ? '' : query).trim().toLowerCase()
      const all = this.orderUserCache || []
      const hit = kw ? all.filter(u => String(u.name || '').toLowerCase().indexOf(kw) >= 0) : all
      this.list.orderUser = hit.slice(0, this.orderUserMax)
    },
    // 无头像兜底统一由 @/utils/avatar 提供（与 User.vue / Xuqiu.vue / head.vue 同一个来源，
    // 保证同一个人在任何页面都是同一个颜色）。
    // ⚠️ 模板里必须先用 v-if 守住 profile：handleUrl 空值安全（null ⇒ 空串，不抛错），
    //    但只判对象非空会渲染出 src="" 的破图（详见 _probe/handleurl-truth.js）。
    avatarColor,
    avatarInitial,
    loadData (pageSize = 40, keepScroll = false) {
      if (!this.user || this.loading.order) return
      this.loading.order = true
      // 实时刷新时记忆滚动位置，避免整页重拉后跳回顶部
      const scrollTop = keepScroll ? document.documentElement.scrollTop : 0
      let self = this
      const dateRange = this.apiFilter.dateRange || []
      this.$get('/js-order/list-by-all-status', {
        searchKey: this.searchKey,
        type: this.type,
        customerUserId: this.apiFilter.customerUserId,
        startDate: dateRange[0] || null,
        endDate: dateRange[1] || null,
        pageSize: pageSize
      }, res => {
        if (['isOutbound', 'isOutboundNoDeliver'].includes(self.type))
          res.pageInfo.list.forEach(item => {
            // 仅「外发未做」走这里：JsOrderItemResult 顶层没有 pics，图片挂在下游 order 上。
            // （原为 JSON.parse(item.pics)，而 item.pics 在此路径恒为 undefined ⇒ SyntaxError
            //   会让整个 forEach 中断、该 tab 列表渲染不出来）
            if (item.order && item.order.pics)
              item.pics = JSON.parse(item.order.pics)
            // item.title = item.order.title
            // item.createUser = item.order.createUser
            // item.customerUser = item.order.customerUser
          })
        else
          // ⚠️ 必须判空再 parse：pics 为 NULL 时 JSON.parse(null) 返回 null（不炸），
          //   但为 '' 时会抛 SyntaxError，把整个 forEach 打断 ⇒ 该 tab 列表一条都渲染不出来。
          //   （同类问题作者已在上面「外发未做」分支修过一次，这里补齐。）
          res.pageInfo.list.forEach(item => { if (item.pics) item.pics = JSON.parse(item.pics) })
        if (keepScroll) {
          // 直接替换，跳过 {} → nextTick 的清空重建，消除闪烁并保留滚动位置
          this.listInfo = res
          this.$nextTick(() => { document.documentElement.scrollTop = scrollTop })
        } else {
          this.listInfo = {}
          this.$nextTick(() => this.listInfo = res)
        }
        this.loading.order = false
      }, () => this.loading.order = false);
    },
    reloadData () {
      this.loadData(this.realList.length, true)
    },
    getApiFilter () {
      let filter;
      if (this.type === 'history') filter = {searchKey: this.searchKey, isOutbound: false}
      if (this.type === 'noDeliver') filter = {searchKey: this.searchKey, isDeliver: false, isOutbound: false}
      if (this.type === 'isOutbound') filter = {searchKey: this.searchKey, isOutbound: true}
      if (this.type === 'isDeliverNoPay') filter = {searchKey: this.searchKey, isDeliver: true, isOutbound: false, isPay: false}
      if (this.type === 'isOutboundNoDeliver') filter = {searchKey: this.searchKey, isDeliver: false, isOutbound: true}

      filter.page = this.listInfo.pageInfo.pageNum
      // 翻页必须带与首次加载一致的 pageSize，否则后端默认 20 会与首屏 40 条 offset 错位导致数据重复
      filter.pageSize = this.listInfo.pageInfo.pageSize || 40
      filter.customerUserId = this.apiFilter.customerUserId
      // 日期区间同样要带上，否则翻页会丢掉日期筛选（后端已支持 startDate/endDate）
      const dateRange = this.apiFilter.dateRange || []
      filter.startDate = dateRange[0] || null
      filter.endDate = dateRange[1] || null
      return filter
    },
    nextPage () {
      // 同 type 守卫：window scroll 在 mounted 就绑定了（见 mounted），移动端地址栏收/展会直接派发 scroll，
      // 而首屏响应回来前 pageInfo 为 undefined ⇒ 这里存在真实可达的抛错窗口。
      if (this.loading.nextPage || !this.listInfo.pageInfo || !this.listInfo.pageInfo.hasNextPage) return
      this.loading.nextPage = true
      this.listInfo.pageInfo.pageNum++;
      let filter = this.getApiFilter();
      this.$get('/js-order/list-next-page', filter, res => {
        if (res.length <= 0) this.listInfo.pageInfo.hasNextPage = false
        this.loading.nextPage = false
        Array.from(res, item => {
          // 同 loadData：pics 为空串时 JSON.parse('') 会抛错，把翻页整体打断（这里也补上守卫）
          if (item.pics) item.pics = JSON.parse(item.pics)
          this.listInfo.pageInfo.list.push(item)
        })
      })
    },
    setShowOrderItemImg (index) {
      this.show.cardItem = {}
      this.show.cardItem[index] = true
    },
    // 订单图片速览板：把图片安全取成数组。
    // 同一条接口按 tab 走两条后端路径，返回形状不同，三种都要认：
    //   1) history / noDeliver / isDeliverNoPay：返回 JsOrder，loadData 已 JSON.parse ⇒ 数组
    //   2) isOutbound：返回 JsOrder，顶层 pics 是 JSON 字符串；loadData 的解析分支要求
    //      item.order 存在，而 JsOrder 没有 order 字段 ⇒ 到这里仍是字符串
    //   3) isOutboundNoDeliver：返回 JsOrderItemResult，顶层无 pics，图片在嵌套的 order.pics
    //   再加 null / 空值兜底
    orderPics (item) {
      if (!item) return []
      const raw = Array.isArray(item.pics) ? item.pics : ((item.order && item.order.pics) || item.pics)
      if (Array.isArray(raw)) return raw.filter(pic => !!pic)
      if (typeof raw === 'string' && raw.trim()) {
        try {
          const arr = JSON.parse(raw)
          return Array.isArray(arr) ? arr.filter(pic => !!pic) : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    // 点缩略图 → 大图查看器（不跳订单）；想看详单仍点整行
    previewPics (item, index) {
      const pics = this.orderPics(item)
      if (!pics.length) return
      this.$refs.imgViewer.init(pics, index)
    },
    taskOpen (task, index) {
      this.$router.push({
        name: '激光订单',
        params: {
          id: task.id ? task.id : 0,
          fromButton: task.id ? undefined : true,
          rowIndex: index,
          filter: this.getApiFilter()
        }
      })
    },
    exportOrders () {
      if (!this.exportMonth) return
      this.exporting = true
      // 后端直接返回 Excel 文件下载，用导航方式触发下载（cookie 会跟随）
      window.location.href = '/js-order/export-month?month=' + this.exportMonth
      setTimeout(() => { this.exporting = false }, 2000)
    },
    routeTo (link) {
      this.$router.push(link)
    },
    friendlyDate (date) {
      return util.friendlyDate1(date)
    },
    getShijihaoshi (task) {
      if (task.tempShijihaoshi !== null)
        return task.tempShijihaoshi;
      else
        task.tempShijihaoshi = dateUtil.getShijihaoshi(task.yujikaishi, task.doneTime);

      return task.tempShijihaoshi;
    },
  },
  mounted () {
    window.$laserOrder = this;
    window.baseURL = this.baseURL;
    this.$(window).on('click', () => {
      this.closeAll();
    })
    this.$(window).on('scroll', this.handleScroll)
  },
  created () {
    console.log('user', this.$store.state.user)
    if (!this.$store.state.user || this.$store.state.user.name !== '江山') {
      this.$router.push('/')
      return
    }
    this.loadData()
    // 趋势图与列表解耦：原先 loadData() 里带 this.$refs.smallChart.reloadChart()，
    // 于是「每次列表刷新」都会顺带重拉一张 31 天聚合图（/js-order/last-month）——
    // 包括每次 WebSocket 推送触发的 reloadData()。列表是 O(已加载行数) 放大，
    // 图表请求量跟着一起放大，而它是一张日粒度聚合图、分钟级变化没有意义。
    // 现在改成独立节奏（首次仍由 SmallChart.vue 的 mounted 自己拉一次）。
    this.chartTimer = setInterval(() => {
      this.$refs.smallChart && this.$refs.smallChart.reloadChart()
    }, 5 * 60 * 1000)
    let self = this
    self.socket = mySocket.create({
      onmessage (data) {
        if ([1, 2].includes(data.type))
          self.reloadData()
      }
    })
  },
  beforeDestroy () {
    clearInterval(this.chartTimer)
    this.socket && this.socket.close()
    this.$(window).off('scroll', this.handleScroll)
  },
  provide () {
    return {
      componentXuqiu: this
    }
  },
}
</script>

<style>
.card {
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  max-width: 1500px;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: flex-start;
}

.card-item {
  animation: v-left-in .3s forwards;
  -webkit-animation: v-left-in .3s forwards;
  width: 200px;
  margin-right: 10px;
  margin-bottom: 20px;
  border-radius: 3px;
  justify-content: flex-start;
  align-items: center;
  transition: width .2s;
  border: 1px solid #CCC;
}

.card-item.a {
  width: 350px;
  box-shadow: 0 0 5px 1px #999;
  max-width: unset;
}

.card-img {
  max-width: calc(100% - 10px);
  margin: 5px;
  border-radius: 3px;
}

.card-mark {
  display: flex;
  justify-content: flex-end;
}

.card-mark .mark {
  margin-right: 0;
  margin-left: 5px;
}

.card-title {
  margin: 5px 10px;
  font-weight: bold;
}

.mark {
  padding: 3px 5px;
  color: #01875b;
  font-size: 10px;
  border-radius: 3px;
}

.mark-err {
  color: #795154;
}

.fc .task-content img {
  max-height: 100%;
  max-width: 20px;
  border-radius: 50%;
  margin: 0 3px;
}

.wc-content {
  padding: 10px;
}

.fc .fc-button.fc-today-button {
  margin-right: 10px;
}

/* ⚠️ 类名必须是 laser-mode-box，不能改回 calendar-mode-box：
   本组样式是非 scoped（全局）的，而 Xuqiu.vue 里也有一个同名的无作用域
   `.calendar-mode-box { position: absolute; right: 0; height: 100% }`，它会被打进
   app.css（index.html 里 rel="stylesheet"）。本组件的 chunk CSS 是 rel="prefetch"、
   路由加载时才注入 —— 虽然注入得更晚，但 **CSS 级联是按属性生效的**：
   只要本规则不声明 position，Xuqiu 那条的 position:absolute 就会"幸存"，
   于是卡片/列表切换重新变成绝对定位、压住筛选栏。改名前实测正是如此。
   改名后彻底与 Xuqiu 解耦，不再受加载顺序影响。 */
.laser-mode-box {
  display: flex;
  align-items: center;
  /* 常规流内右对齐：不再绝对定位，因此不会覆盖到筛选栏上 */
  margin-left: auto;
  flex-shrink: 0;
}

.laser-mode-box .img-btn {
  width: auto !important;
  margin-left: 10px;
  padding: 0 10px;
}

.laser-mode-box .img-btn.a {
  color: white;
}

.laser-mode-box .img-btn img {
  margin-right: 5px;
}
</style>

<style scoped>
.img-btn {
  height: 33px;
  width: 40px;
  background: #fff;
  border-radius: 3px;
  transition: background .2s ease;
}

.img-btn img {
  width: 20px;
  height: 20px;
}

.img-btn.a {
  background: #516079;
}

.content {
  position: relative;
}

.sx.main-btn button {
  margin: 0;
}

.main-btn {
  position: fixed;
  right: 5vw;
  bottom: 10vh;
  z-index: 100;
}

.sx > * {
  margin-right: 5px;
}

/* 「下单人」下拉外壳：承载外边距/不收缩，并作为「已选人」头像的定位父级 */
.order-user-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  flex-shrink: 0;
}

/* 「下单人」下拉：紧凑宽度，只占必要空间（别再像早先那样挤爆筛选栏） */
.order-user-select {
  width: 150px;
}

/* 已选下单人头像：叠在输入框左侧；pointer-events:none 保证它不吃点击（点它等于点输入框） */
.order-user-picked {
  position: absolute;
  left: 7px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  pointer-events: none;
  z-index: 2;
}

/* 有已选头像时给输入框左侧留出空间（::v-deep 穿透进 element-ui 内部 input） */
.order-user-wrap.has-picked ::v-deep .el-input__inner {
  padding-left: 32px;
}

/* 下拉每一项：头像 + 姓名 */
.order-user-opt {
  display: flex;
  align-items: center;
}

.order-user-opt-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 6px;
}

/* 无头像兜底（姓名首字圆点）：与 .order-user-opt-avatar 共用尺寸/圆角，只额外补居中与字色 */
.order-user-opt-initial,
.order-user-picked-initial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.order-user-opt-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 筛选栏这轮多了一个「下单人」下拉，窄桌面允许换行，避免横向溢出。
   （.content 最小宽 700px、最大 1200px；行内元素总宽约 1000px，正常屏幕不会触发换行） */
.navs {
  flex-wrap: wrap;
  row-gap: 6px;
}

/* 浏览器自动填充诱饵：0 尺寸、不可见、不可交互。
   作用是把 Chrome 对「已保存账号」的自动填充引到这个假框上，
   不让它落到日期区间输入框（否则日期框被填上账号名乃至顶开日历面板）。 */
.autofill-decoy {
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  border: 0;
  opacity: 0;
  pointer-events: none;
}

/* 「下单人」并入搜索框后，输入框要放得下提示文字：
   原来 el-input 只有约 163px（弹性的 max-content），提示被截断，等于没提示。
   移动端另有 100% 宽的覆盖规则，不影响。 */
.search-input {
  width: 240px;
}

.tb-head {
  cursor: auto;
}

.t {
  height: 44px;
  user-select: none;
}

.nav-p .user > span {
  line-height: 14px;
}

/* 订单图片速览板：表格内直接看图纸缩略图；点图看大图、点整行开订单 */
/* 列表行统一加高到 60px（原为内容自适应），给图片列留出空间 */
.i-tab td {
  height: 60px;
}

.pic-head {
  /* 2 × 80px 缩略图 + 3 处 4px 间距 + +N 徽标 */
  width: 205px;
}

.pic-cell {
  white-space: nowrap;
}

.pic-strip {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pic-thumb {
  /* 宽 80px；高 48px 是为了塞进 60px 的行高 */
  width: 80px;
  height: 48px;
  object-fit: cover;
  border-radius: 3px;
  border: 1px solid #dfe1e6;
  background: #f4f5f7;
  cursor: zoom-in;
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
}

.pic-thumb:hover {
  transform: scale(1.15);
  box-shadow: 0 2px 7px 1px #505f79;
  border-color: #01875b;
}

.pic-more {
  height: 48px;
  min-width: 34px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #505f79;
  background: #f4f5f7;
  border: 1px dashed #ccced3;
  border-radius: 3px;
  cursor: zoom-in;
}

.pic-none {
  color: #c1c7d0;
}

@media only screen and (max-width: 749px) {

  /* 移动端另有专门的列表视图，速览板不必挤进窄表 */
  .pic-head,
  .pic-cell {
    display: none;
  }

  .laser-mode-box {
    flex-direction: row-reverse;
    position: relative;
    margin: 10px 10px 0;
  }

  .t {
    padding: 10px;
    margin-left: 0;
    margin-right: 0;
  }

  .sx button {
    margin: 0;
  }

  .item-title {
    justify-content: flex-start;
  }

  .order-user-wrap {
    /* 手机端整行铺满：宽度必须减掉左右各 10px 外边距，否则 100%+20px 会横向溢出；
       同时放开 flex-shrink（桌面端为 0，这里若保持 0 就不会收缩，一样溢出） */
    display: flex;
    width: calc(100% - 20px);
    margin: 0 10px 8px;
    flex-shrink: 1;
  }

  .order-user-select {
    width: 100%;
  }

  .search-input {
    margin: 0 10px;
    width: calc(100% - 20px);
  }
}
</style>
